"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var axios_1 = __importDefault(require("axios"));
var index_1 = __importDefault(require("../header/index"));
var index_2 = __importDefault(require("../panel/index"));
var InputGroup_1 = __importDefault(require("../ui-components/InputGroup"));
var button_control_1 = __importDefault(require("../button-control"));
var Credentials_1 = __importDefault(require("./Credentials"));
var AlertComponent_1 = __importDefault(require("../ui-components/AlertComponent"));
var assets_1 = __importDefault(require("../assets"));
var List_1 = __importDefault(require("./List"));
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { name: '', processing: false, error: undefined, clients: props.clients };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.successResponse = _this.successResponse.bind(_this);
        _this.errorResponse = _this.errorResponse.bind(_this);
        return _this;
    }
    Form.prototype.handleChange = function (evt) {
        var value = evt.target.value;
        if (!value) {
            return;
        }
        this.setState({ name: value });
    };
    Form.prototype.handleSubmit = function (evt) {
        evt.preventDefault();
        var _a = this.state, processing = _a.processing, name = _a.name;
        if (processing) {
            return;
        }
        this.setState({ processing: true, error: undefined });
        axios_1.default.post('/settings/api/clients', { name: name }).then(this.successResponse).catch(this.errorResponse);
    };
    Form.prototype.handleRevoke = function (client) {
        this.setState({ error: undefined });
        var self = this;
        axios_1.default.post('/settings/api/revoke', { client_id: client.id }).then(function () {
            self.setState({ clients: self.state.clients.filter(function (curr) { return curr !== client; }) });
        }).catch(this.errorResponse);
    };
    Form.prototype.successResponse = function (response) {
        if (!response.data) {
            return;
        }
        var client = response.data;
        var clients = this.state.clients;
        clients.push(client);
        this.setState({ processing: false, credentials: { id: client.clientId, secret: client.secret }, clients: clients });
    };
    Form.prototype.errorResponse = function (error) {
        var message = 'Something went wrong';
        var response = error.response;
        if (response && response.data.message) {
            message = response.data.message;
        }
        this.setState({ processing: false, error: message });
    };
    Form.prototype.render = function (_a, _b) {
        var _this = this;
        var url = _a.url;
        var name = _b.name, processing = _b.processing, error = _b.error, credentials = _b.credentials, clients = _b.clients;
        return (preact_1.h("section", { className: 'oauth2-create-client' },
            preact_1.h(index_1.default, { title: 'API', disableCancelButton: true, disableSaveButton: true }),
            preact_1.h(List_1.default, { clients: clients, onRevokeButtonClick: function (e) { return _this.handleRevoke(e); } }),
            preact_1.h(AlertComponent_1.default, { messageType: error ? 'error' : null, message: error }),
            preact_1.h("form", { onSubmit: this.handleSubmit },
                preact_1.h(index_2.default, { title: 'OAuth2' },
                    preact_1.h(InputGroup_1.default, { title: 'Label *', meta: 'Use a label as a reminder of why you generated this client.', required: true, placeholder: 'Enter an application name', disabled: processing || !!credentials, onChange: this.handleChange, value: name }),
                    !credentials && preact_1.h(button_control_1.default, { variant: 'primary', type: 'submit', title: 'Create an OAuth2 client', isLoading: processing }),
                    credentials && preact_1.h(Credentials_1.default, { credentials: credentials }))),
            preact_1.h("a", { href: url, target: '_blank' },
                "API Documentation",
                preact_1.h(assets_1.default, { icon: 'externalLink' }))));
    };
    return Form;
}(preact_1.Component));
exports.default = Form;
